import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=6c7bca1a&"
import script from "./Draggable.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Draggable.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports